import React, { FunctionComponent } from 'react';
import { QuickTipWhite } from '@lt/components/icons-react';
import { StyledBubble, StyledLink, Text, Title } from './style';

export const BestPriceTooltip: FunctionComponent = () => {
  return (
    <StyledBubble
      closeable
      title={
        <Title>
          На Level.Travel вы всегда
          <br />
          бронируете по лучшей цене
        </Title>
      }
      text={
        <Text>
          Если вы сможете найти такой же тур на другом сайте по более низкой цене, просто свяжитесь
          с нами, и мы вернем Вам двойную разницу!
        </Text>
      }
      renderExtras={() => (
        <StyledLink href="/packages/best_price_guarantee.pdf">Подробнее о гарантии</StyledLink>
      )}
    >
      <QuickTipWhite />
    </StyledBubble>
  );
};
